'use client'

import { sendRegionsChangeClick } from '../../analytics/events'
import { useRegions } from '../../contexts/RegionsProvider/RegionsProvider'
import type { SizeGuideRegion } from '../../types'
import { CustomDropdown } from './CustomDropdown/CustomDropdown'

import styles from './Regions.module.scss'

export function Regions(): React.ReactNode {
	const { regions, selectedRegionId, selectRegionId } = useRegions()

	const handleRegionChange = (region?: SizeGuideRegion): void => {
		sendRegionsChangeClick()
		if (region) {
			selectRegionId(region)
		}
	}

	if (!regions.length) {
		return null
	}

	return (
		<CustomDropdown
			regions={regions}
			onChange={handleRegionChange}
			value={selectedRegionId}
			className={styles.customDropdown}
		/>
	)
}
